import React from 'react';

interface StarIconProps {
  size?: number;
  color?: string;
}

const StarIcon: React.FC<StarIconProps> = ({
  size = 20,
  color = 'currentColor',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 8 8"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.99897 0C3.88558 0 3.77456 0.0324389 3.67901 0.0934874C3.58468 0.153756 3.50931 0.239423 3.46155 0.340598L2.55438 2.17208C2.55259 2.17568 2.55089 2.17931 2.54926 2.18299C2.54885 2.18389 2.54821 2.18469 2.54741 2.18528C2.5466 2.18587 2.54566 2.18624 2.54466 2.18635C2.54118 2.18673 2.53771 2.18718 2.53425 2.18769L0.536771 2.48361C0.426368 2.49435 0.321088 2.53578 0.232908 2.60332C0.141667 2.67321 0.0726488 2.76806 0.0342144 2.87637C-0.00421993 2.98469 -0.0104217 3.10183 0.0163606 3.2136C0.0430393 3.32493 0.101307 3.42618 0.184145 3.50518L1.6463 4.91593L1.64963 4.91909C1.65172 4.92105 1.65329 4.92349 1.65419 4.9262C1.6551 4.92891 1.65531 4.93181 1.65481 4.93462L1.65449 4.93649L1.30606 6.97557C1.28692 7.08608 1.29904 7.20025 1.34122 7.30414C1.38345 7.40825 1.45406 7.49837 1.54499 7.56431C1.63593 7.6302 1.74354 7.66928 1.85558 7.67705C1.96741 7.68483 2.07917 7.66111 2.17819 7.60865L2.17879 7.60831L3.9785 6.65717C3.98495 6.65437 3.99193 6.65288 3.99898 6.65288C4.00604 6.65288 4.01301 6.65437 4.01947 6.65717L5.81914 7.60831C5.91823 7.66094 6.03046 7.68488 6.14234 7.67705C6.2544 7.66928 6.362 7.6302 6.45297 7.56431C6.54389 7.49837 6.61451 7.40825 6.65674 7.30414C6.69891 7.20025 6.71109 7.08665 6.692 6.9762L6.69189 6.97557L6.34349 4.93648L6.34314 4.93462C6.34263 4.93181 6.34286 4.92891 6.34377 4.9262C6.34463 4.92349 6.34623 4.92105 6.34829 4.91909L6.35166 4.91593L7.81383 3.50516C7.89663 3.42616 7.95491 3.32492 7.9816 3.2136C8.00834 3.10183 8.00217 2.98469 7.96371 2.87637C7.92531 2.76806 7.85629 2.67321 7.76503 2.60332C7.67686 2.53578 7.5716 2.49435 7.4612 2.48361L5.4637 2.18769C5.46024 2.18718 5.45677 2.18673 5.45329 2.18635C5.45229 2.18624 5.45134 2.18587 5.45054 2.18528C5.44973 2.18469 5.4491 2.18389 5.44869 2.18299C5.44706 2.17931 5.44535 2.17568 5.44357 2.17208L4.53639 0.34059C4.48863 0.239419 4.41326 0.153754 4.31894 0.0934874C4.22338 0.0324389 4.11236 0 3.99897 0Z"
      fill={color}
    />
  </svg>
);

export default StarIcon;
